import { FlowStepData } from "../FlowStepData";
import { MultiExecutableOutputDefinition } from "../../../Common/Execution/MultiExecutable";
import { RuleExecutable } from "../../../Common/Execution/RuleExecutable";
import { BooleanDataDefinition } from "../../../Common/Data/Definitions/BooleanDataDefinition";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { StatementRuleConfiguration } from "../../../Rule/Statement/StatementRuleConfiguration";
import { IntersectionRuleConfiguration } from "../../../Rule/Intersection/IntersectionRuleConfiguration";
import { TreeRuleConfiguration } from "../../../Rule/Tree/TreeRuleConfiguration";
import { TextMergeConfiguration } from "../../../TextMerge/TextMergeConfiguration";

export enum RuleStepStrategy {
    Value = "value",
    Paths = "paths",
}

export abstract class BaseFlowRuleStep extends FlowStepData {
    static OUTCOME_NAME = "outcomeName";
    static OUTCOME_STRATEGY = "outcomeStrategy";

    abstract executable: RuleExecutable;

    outcomeStrategy: RuleStepStrategy = RuleStepStrategy.Value;

    outcomeName?: string;

    get canChangeOutputStrategy(): boolean {
        // todo: this code needs to be in each of the rule classes.

        let ruleResult = this.executable.getRuleResult();

        if (ruleResult instanceof BooleanDataDefinition) return true;

        if (ruleResult instanceof StringDataDefinition) {
            if (ruleResult.validValues.length > 0) return true;
        }

        return false;
    }

    get needSetOutcomeName(): boolean {
        // todo: this code needs to be in each of the rule classes.
        if (
            this.executable instanceof StatementRuleConfiguration ||
            this.executable instanceof IntersectionRuleConfiguration ||
            this.executable instanceof TreeRuleConfiguration ||
            this.executable instanceof TextMergeConfiguration
        ) {
            let ruleResult = this.executable.getRuleResult();

            if (this.outcomeStrategy === RuleStepStrategy.Paths) {
                if (ruleResult instanceof BooleanDataDefinition) return false;
                if (ruleResult instanceof StringDataDefinition && ruleResult.validValues.length > 0) return false;
            }

            // if (ruleResult.name === "") return true;

            return true;

            // try {
            //   let datadef = this.executable.getInputDefinition();
            //   let field = DataUtilities.getFieldFromDataDefinitionByProperty(
            //     datadef.fields,
            //     ruleResult.name
            //   );
            //   if (!field) return true;
            //   return false;
            // } catch (e) {
            //   return true;
            // }
        }
        return false;
    }

    getOutcomes(): MultiExecutableOutputDefinition[] {
        let ruleResult = this.executable.getRuleResult();

        if (this.canChangeOutputStrategy && this.outcomeStrategy === RuleStepStrategy.Paths) {
            if (ruleResult instanceof BooleanDataDefinition) {
                return ["true", "false"].map((value) => {
                    return new MultiExecutableOutputDefinition(value);
                });
            }

            if (
                ruleResult instanceof StringDataDefinition &&
                (ruleResult as StringDataDefinition).validValues &&
                (ruleResult as StringDataDefinition).validValues.length !== 0
            ) {
                return ruleResult.validValues.map((value) => {
                    return new MultiExecutableOutputDefinition(value);
                });
            }
        }

        if (this.needSetOutcomeName) {
            ruleResult.name = this.outcomeName || (this.name || "").replace(/[^a-zA-Z]/g, "") || this.__type + "result";

            return [new MultiExecutableOutputDefinition("done", [ruleResult])];
        }

        return [new MultiExecutableOutputDefinition("done", [ruleResult])];
    }
}
